/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Hero_Voice_HistoryInputs */

const en_homepage_hero_voice_history = /** @type {(inputs: Homepage_Hero_Voice_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const es_homepage_hero_voice_history = /** @type {(inputs: Homepage_Hero_Voice_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historia`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {Homepage_Hero_Voice_HistoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_hero_voice_history = /** @type {((inputs?: Homepage_Hero_Voice_HistoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Hero_Voice_HistoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_hero_voice_history(inputs)
	return en_homepage_hero_voice_history(inputs)
});